<template>
  <v-container
    id="Login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="6"
      >
        <v-slide-y-transition appear>
          <v-card
            class="pa-3 pa-md-5 mx-auto"
            light
          >
            <div
              v-if="!tokencontrato"
            >
              <pages-heading class="text-center text-h2">
                Empresa não encontrada
              </pages-heading>
            </div>
            <div v-else>
              <div
                v-if="inativo"
              >
                <div
                  class="transition-swing font-weight-light text-center text-h3"
                  v-text="inativo"
                /> <br>
                <v-btn
                  id="idSuport2"
                  :color="corPrimaria"
                  dark
                  class="col-3 col-sm-4"
                  target="_blank"
                  :href="whatsapp"
                  @click="reload()"
                >
                  <v-icon
                    id="iconSuport"
                    color="#ffffff"
                  >
                    mdi-account-question
                  </v-icon>
                  <h5>SUPORTE</h5>
                </v-btn>
              </div>
              <div
                v-else
              >
                <div id="imagem">
                  <v-img
                    :src="imagem"
                  />
                </div>
                <pages-heading
                  id="cabecalho"
                  class="text-center text-h2"
                  :style="styleObject"
                >
                  {{ empresaNome }}
                </pages-heading>
                <pages-heading
                  class="text-h3"
                  :style="styleObject"
                >
                  <b>Faça o login</b>
                </pages-heading>
                <!-- <validation-observer> -->
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="logar"
                >
                  <v-row class="text-center">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        id="usernameId"
                        v-model="login.username"
                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                        :color="corPrimaria"
                        class="text-h6"
                        label="Usuário(CPF ou CNPJ)"
                        type="tel"
                        prepend-inner-icon="mdi-account"
                        required
                      />
                      <v-text-field
                        id="passwordId"
                        v-model="login.password"
                        required
                        :type="inputType ? 'text' : 'password'"
                        label="Senha"
                        class="text-h6"
                        :color="corPrimaria"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="inputType ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="inputType = !inputType"
                        @keyup.enter="logar()"
                      />
                      <div
                        class="text-left"
                      >
                        Esqueceu sua senha?
                        <span>
                          <router-link
                            to="/recover"
                            :style="styleObject"
                          >Clique aqui para recuperar.</router-link>
                          <!-- <router-link
                            :to="{name: 'Recover', params: {tokencontrato: tokencontrato}}"
                            :style="styleObject"
                          >Clique aqui para recuperar.</router-link> -->
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="5"
                    >
                      <v-btn
                        id="logarId"
                        small
                        class="v-btn--block"
                        :color="corPrimaria"
                        @click="logar()"
                      >
                        Acessar o sistema
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col
                      cols="12"
                      lg="12"
                    >
                      <div
                        class="text-center"
                      >
                        Ainda não possui uma conta?
                        <span>
                          <router-link
                            :to="{name: 'Registrar', params: {tokencontrato: tokencontrato}}"
                            :style="styleObject"
                          >Cadastra-se agora</router-link>
                        </span>
                      </div>
                      <div
                        class="text-center"
                      >
                        Para saber como tratamos os dados pessoais visite a nossa
                        <span>
                          <a
                            href="https://www.magistech.com.br/politica-de-privacidade/"
                            target="_blank"
                            :style="styleObject"
                          >
                            Política de Privacidade.
                          </a>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      lg="12"
                    >
                      <v-btn
                        id="idSuport"
                        :color="corPrimaria"
                        dark
                        small
                        class="col-12 col-sm-2"
                        target="_blank"
                        :href="whatsapp"
                      >
                        <v-icon
                          id="iconSuport"
                          color="#ffffff"
                        >
                          mdi-account-question
                        </v-icon>
                        <h5>SUPORTE</h5>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <base-material-snackbar
                    v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :top="true"
                    :type="snackbar.color"
                  >
                    {{ snackbar.message }}
                  </base-material-snackbar>
                </v-form>
              </div>
              <!-- </validation-observer> -->
            </div>
          </v-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Login from '../../services/login'
  import utils from '../../services/utils'
  export default {

    name: 'PageLogin',
    components: {
      PagesHeading: () => import('./components/Heading'),
    },
    mixins: [utils],

    data: () => ({
      exibePf: true,
      valid: false,
      tokencontrato: '',
      login: {
        username: '',
        password: '',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      verifylink: '',
      inativo: '',
      imagem: localStorage.imagem,
      empresaNome: '',
      whatsapp: 'https://api.whatsapp.com/send?phone=55' + localStorage.whatsapp,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: '',
        timeout: 3000,
      },

      user: [],
      dialog: {
        visible: false,
        message: '',
      },
      validuser: false,
      inputType: false,
    }),

    mounted () {
      this.valid = false
      this.invalid = true

      this.tokencontrato = localStorage.tokencontrato

      Login.verificaEmpresa(this.tokencontrato).then(resposta => {
        this.empresaNome = resposta.data.empresa
      }).catch(e => {
        if (e.data.errors === 'Empresa não encontrada') {
          this.empresaNome = ''
          this.tokencontrato = ''
          this.showSnackbar('error', 3000, 'Empresa não encontrada.')
        }
      })
    },

    methods: {
      reload () {
        location.reload()
      },

      logar () {
        if (this.validPreenchimento()) {
          Login.logar(this.login, this.tokencontrato).then(resposta => {
            if (resposta.data.result === 'cadastro-usuario-ok') {
              this.login.validuser = true

              if (resposta.data.inativo) {
                this.inativo = resposta.data.inativo
              } else {
                this.showSnackbar('success', 3000, 'Login realizado com sucessso')
                localStorage.username = resposta.data.username
                localStorage.nome = resposta.data.nome
                localStorage.email = resposta.data.email
                localStorage.chaveativacao = resposta.data.chaveativacao
                localStorage.status = resposta.data.status
                localStorage.contrato_id = resposta.data.contrato_id
                localStorage.bloqueado = resposta.data.bloqueado
                localStorage.obsBloqueado = resposta.data.obsBloqueado
                this.user = resposta.data

                this.emitLogin()

                this.$router.push('/dashboard')
              }
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            } else if (e.data.message === 'ERRO LOGIN: campo username não foi informado') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Usuário não informado.')
            } else if (e.data.message === 'ERRO LOGIN: campo password não foi informado') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Senha não informada.')
            } else if (e.data.message === 'ERRO LOGIN: campo CPF informado inválido') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Username informado inválido.')
            } else if (e.data.message === 'ERRO LOGIN: campo CNPJ informado inválido') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Username informado com formato inválido.')
            } else if (e.data.message === 'ERRO LOGIN: Username informado inválido') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Username informado não encontrado, favor confirmar os dados ou se cadastra-se.')
            } else if (e.data.message === 'ERRO LOGIN: Username ou Password informado não conferem') {
              this.login.validuser = false
              this.showSnackbar('error', 3000, 'Username ou Password informado não conferem')
            }
          }).finally(f => { this.exibeProgress = false })
        } else {
          if (!this.login.password) {
            if (!this.login.username) {
              this.showSnackbar('error', 5000, 'Não foi informado usuário e senha, favor confererir os dados informados e tentar novamente.')
            } else {
              this.showSnackbar('error', 5000, 'Não foi informado a senha, favor confererir os dados informados e tentar novamente.')
            }
          } else if (this.login.username.length === 14) {
            this.showSnackbar('error', 5000, 'CPF informado inválido, favor conferir os dados informados.')
          } else if (this.login.username.length === 18) {
            this.showSnackbar('error', 5000, 'CNPJ informado inválido, favor conferir os dados informados.')
          } else if (!this.login.username) {
            this.showSnackbar('error', 5000, 'Não foi informado o usuário, favor confererir os dados informados e tentar novamente.')
          }
        }
      },

      validPreenchimento () {
        if (this.login.password && (this.login.username.length === 18 || this.login.username.length === 14)) {
          return true
        } else {
          return false
        }
      },

      emitLogin () {
        this.$root.$emit('dados-login', this.user)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      showDialog (message) {
        this.dialog.visible = true
        this.dialog.message = message
      },

      salvaDadosOffline () {
        // Dados =========================================v
        localStorage.username = this.login.username
        localStorage.password = this.login.password
        // Dados do usuario =========================================^
      },

      // carregaDadosOffline () {
      //   // Dados do usuario Offline =========================================v
      //   if (localStorage.nome) {
      //     this.login.nome = localStorage.nome
      //   }

      //   if (localStorage.username) {
      //     this.login.username = localStorage.username
      //   }

      //   if (localStorage.email) {
      //     this.password.email = localStorage.email
      //   }

      //   // Dados do usuario Offline =========================================^
      // },
    },
  }
</script>

<style lang="sass">
  .v-text-field input
    font-size: 1.2em

  #login
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial

  #cabecalho
    color: #4caf50
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif
    font-weight: 800 !important

  #imagem
    margin-left: 30%
    margin-right: 25%
    width: 40%
    height: 40%

  #idSuport
    margin-left: 35%
    margin-right: 30%

  #logarId
    border-radius: 8px

  #idSuport
    float: right
    margin-right: 2rem
    border-radius: 1.8rem

  #idSuport2
    margin: 0rem 0rem 0rem 12rem
    border-radius: 1.8rem

</style>
